import { z } from 'zod';
import { lineSchema } from '@/models/lineSchema';
import { reactionProductSchema } from '@/models/reactionProductSchema';
import { annotationSchema } from '@/models/annotationSchema';
import { operatorSchema } from '@/models/operatorSchema';
import { reactionModifierSchema } from '@/models/reactionModifierSchema';

export const newReactionSchema = z.object({
  id: z.number().int().positive(),
  elementId: z.string(),
  reactionId: z.string(),
  kinetics: z.record(z.unknown()).nullable(),
  line: lineSchema,
  map: z.number(),
  modifiers: z.array(reactionModifierSchema),
  name: z.string(),
  notes: z.string(),
  operators: z.array(operatorSchema),
  processCoordinates: z.null(),
  products: z.array(reactionProductSchema),
  reactants: z.array(reactionProductSchema),
  references: z.array(annotationSchema),
  reversible: z.boolean(),
  sboTerm: z.string(),
  visibilityLevel: z.string().nullable(),
  z: z.number(),
});
